module.exports = __webpack_public_path__ + "img/carousel.e6e5d4e2.svg";